import styled from '@emotion/styled';
import {
  Column,
  device,
  Row,
  typography,
  useMedia,
  mobileGutterMargin,
} from '@landsbankinn/ui';
import type { FC } from 'react';
import React, { forwardRef } from 'react';
import { animated } from 'react-spring';
import type { ImgAr, ImgSource } from '../../components/img/Img';
import { Img } from '../../components/img/Img';

export const Host = styled(animated.div)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  background-color: ${(props) => props.theme.colors.background};
`;

const Overflow = styled.div`
  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};
  margin-bottom: 36px;

  ${mobileGutterMargin}

  @media ${device.tablet} {
    overflow: hidden;
    height: 100%;
    margin: 0;

    > * {
      height: 100%;
    }
  }
`;

const Body = styled.div`
  @media ${device.tablet} {
    display: flex;
    padding: 0 35px;
    height: 100%;
    flex-flow: column;
    justify-content: center;
  }
`;

const Title = styled.h2`
  ${typography.h3};

  margin-bottom: 30px;

  @media ${device.tablet} {
    margin-top: auto;
  }
`;

const Copy = styled.div`
  ${typography.body}
  margin-bottom: 30px;
`;

const CardAction = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${(props) => props.theme.colors.primary};

  @media ${device.tablet} {
    margin-top: auto;
  }
`;

export interface CardProps {
  title: string | null;
  description: React.ReactNode;
  image?: ImgSource;
  ar?: ImgAr;
  imageAspect?: number;
  action?: React.ReactNode;
  isSplittedCard?: boolean;
}

export const HorizontalOtherCard: FC<CardProps> = forwardRef(function HOCard(
  { title, description, image, ar, action, isSplittedCard, ...rest }: CardProps,
  ref,
) {
  const isMobile = useMedia('sm');

  const aspectRatio = isMobile ? 'ar_1_1' : ar;
  return (
    <Host ref={ref as any}>
      <Row>
        <Column md={{ width: 6 / 12 }} lg={{ width: 8 / 12 }}>
          {!!image && (
            <Overflow>
              <Img src={image} ar={aspectRatio} />
            </Overflow>
          )}
        </Column>
        <Column md={{ width: 6 / 12 }} lg={{ width: 4 / 12 }}>
          <Body>
            <Title>{title}</Title>
            <Copy>{description}</Copy>
            {!!action && <CardAction>{action}</CardAction>}
          </Body>
        </Column>
      </Row>
    </Host>
  );
});
